module.exports = __webpack_public_path__ + "img/icon-record2.6a0a6ad9.svg";